import { restApi } from '../../services/Api'
import { isEmpty } from 'ramda'
import { getEmpresaId, getUsuarioRealm } from '../../utils/Utils'

const consultaHistoricoRepository = {}

consultaHistoricoRepository.getUltimaFicha = async params => {
  const where = {}
  if (params.query.cpf) {
    where.cpf = { like: params.query.cpf.replace(/[^\d]/g, '') }
  }
  if (params.query.cpfcnpj) {
    where.cpfcnpj = { like: params.query.cpfcnpj.replace(/[^\d]/g, '') }
  }
  if (params.query.placa) {
    where.placa = { ilike: params.query.placa.replace(/\W/g, '') }
  }
  if (getUsuarioRealm() === 'embarcador') {
    where.empresaId = getEmpresaId()
  }
  if (isEmpty(where)) {
    return { ok: true, data: [] }
  }
  const filter = {
    where,
    order: ['createdAt DESC'],
    limit: 1
  }
  return restApi.get('/solicitacoes/historico', { filter })
}

consultaHistoricoRepository.getHistorico = async params => {
  const where = {}
  if (params.query.cpf) {
    where.cpf = { like: params.query.cpf.replace(/[^\d]/g, '') }
  }
  if (params.query.cpfcnpj) {
    where.cpfcnpj = { like: params.query.cpfcnpj.replace(/[^\d]/g, '') }
  }
  if (params.query.placa) {
    where.placa = { ilike: params.query.placa.replace(/\W/g, '') }
  }
  const filter = {
    where
  }
  if (!isEmpty(where)) {
    return restApi.get('/consulta-historico', { filter })
  } else {
    return {
      ok: false,
      data: null
    }
  }
}

consultaHistoricoRepository.getMotoristaFrotista = async params => {
  const where = {}
  if (params.query.cpf) {
    where.cpf = { like: params.query.cpf.replace(/[^\d]/g, '') }
  }

  const filter = { where }

  if (!isEmpty(where)) {
    return restApi.get('/consulta-historico/kmm/motorista', { filter })
  }

  return {
    ok: false,
    data: null
  }
}

export default consultaHistoricoRepository
